var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "card-verification-details page-container" },
    [
      _c("div", { staticClass: "page-title" }, [
        _vm._v(
          " " + _vm._s(_vm.$t("customerService.card_verification_search")) + " "
        ),
      ]),
      _c(
        "div",
        { staticClass: "filter-section-container" },
        [
          _c("div", { staticClass: "filter-fixed" }, [
            _c("span", { staticClass: "filter-fixed-title" }, [
              _vm._v(_vm._s(_vm.$t("data.filter_section"))),
            ]),
            _c("i", {
              staticClass: "el-icon-arrow-down filter-fixed-arrow",
              class: { "fiter-icon-arrow-route": !_vm.showFilterContent },
              on: { click: _vm.onClickFixedArrow },
            }),
          ]),
          _c("el-collapse-transition", [
            _c(
              "div",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.showFilterContent,
                    expression: "showFilterContent",
                  },
                ],
              },
              [
                _c(
                  "div",
                  {
                    staticClass: "filter-content",
                    attrs: { id: "filter-content" },
                  },
                  [
                    _c(
                      "div",
                      { staticClass: "filter-item" },
                      [
                        _c("div", { staticClass: "filter-item-label" }, [
                          _vm._v(_vm._s(_vm.$t("data.merchant_order_id"))),
                        ]),
                        _c("el-input", {
                          staticClass: "filter-item-value",
                          attrs: {
                            size: "small",
                            type: "text",
                            maxlength: "32",
                            clearable: "",
                          },
                          model: {
                            value: _vm.search.mch_order_id,
                            callback: function ($$v) {
                              _vm.$set(_vm.search, "mch_order_id", $$v)
                            },
                            expression: "search.mch_order_id",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "div",
                      { staticClass: "filter-item" },
                      [
                        _c("div", { staticClass: "filter-item-label" }, [
                          _vm._v(_vm._s(_vm.$t("data.transaction_id"))),
                        ]),
                        _c("el-input", {
                          staticClass: "filter-item-value",
                          attrs: {
                            size: "small",
                            type: "text",
                            maxlength: "32",
                            clearable: "",
                          },
                          model: {
                            value: _vm.search.transaction_id,
                            callback: function ($$v) {
                              _vm.$set(_vm.search, "transaction_id", $$v)
                            },
                            expression: "search.transaction_id",
                          },
                        }),
                      ],
                      1
                    ),
                    _c("div", { staticClass: "filter-item" }),
                  ]
                ),
                _c("div", { staticClass: "filter-operate" }, [
                  _c("div", { staticClass: "filter-operate-left" }),
                  _c(
                    "div",
                    { staticClass: "filter-operate-right" },
                    [
                      _c(
                        "el-button",
                        {
                          staticClass: "search-btn mb-10",
                          attrs: { size: "small" },
                          on: { click: _vm.onClickReset },
                        },
                        [_vm._v(_vm._s(_vm.$t("components.clear")))]
                      ),
                      _c(
                        "el-button",
                        {
                          staticClass: "search-btn mb-10",
                          attrs: {
                            type: "primary",
                            size: "small",
                            icon: "el-icon-search",
                          },
                          on: { click: _vm.handleFilter },
                        },
                        [_vm._v(_vm._s(_vm.$t("components.search")))]
                      ),
                    ],
                    1
                  ),
                ]),
              ]
            ),
          ]),
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "tableContainer" },
        [
          _c(
            "el-table",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.listLoading,
                  expression: "listLoading",
                },
              ],
              staticStyle: { width: "100%" },
              attrs: {
                data: _vm.tableData,
                stripe: "",
                fit: "",
                "highlight-current-row": "",
              },
            },
            [
              _c("el-table-column", {
                attrs: {
                  label: _vm.$t("data.transaction_id"),
                  align: "center",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c("span", [_vm._v(_vm._s(scope.row.transaction_id))]),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  label: _vm.$t("data.merchant_order_id"),
                  align: "center",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c("span", [
                          _vm._v(_vm._s(scope.row.merchant_order_id)),
                        ]),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { label: _vm.$t("data.account_no"), align: "center" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c("span", [_vm._v(_vm._s(scope.row.account_no))]),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  label: _vm.$t("data.account_bank_code"),
                  align: "center",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c("span", [
                          _vm._v(_vm._s(scope.row.account_bank_code)),
                        ]),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { label: _vm.$t("data.account_name"), align: "center" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c("span", [_vm._v(_vm._s(scope.row.account_name))]),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  label: _vm.$t("data.account_status"),
                  align: "center",
                  "min-width": "110",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c(
                          "el-tag",
                          {
                            staticClass: "tag-custom",
                            attrs: {
                              type: _vm.getAccountStatusType(
                                scope.row.account_validate_result
                              ),
                            },
                          },
                          [
                            _vm._v(
                              _vm._s(
                                _vm.getAccountStatusLabel(
                                  scope.row.account_validate_result
                                )
                              )
                            ),
                          ]
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  label: _vm.$t("data.order_status"),
                  align: "center",
                  "min-width": "160",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c(
                          "el-tag",
                          {
                            staticClass: "tag-custom",
                            attrs: {
                              type: _vm.getTransactionStatusType(
                                scope.row.transaction_status
                              ),
                            },
                          },
                          [
                            _vm._v(
                              _vm._s(
                                _vm.getTransactionStatusLabel(
                                  scope.row.transaction_status
                                )
                              )
                            ),
                          ]
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  label: _vm.$t("data.name_match_result"),
                  align: "center",
                  "min-width": "120",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c(
                          "el-tag",
                          {
                            staticClass: "tag-custom",
                            attrs: {
                              type: _vm.getNameMatchResultType(
                                scope.row.name_match_result
                              ),
                            },
                          },
                          [
                            _vm._v(
                              _vm._s(
                                _vm.getNameMatchResultLabel(
                                  scope.row.name_match_result
                                )
                              )
                            ),
                          ]
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  label: _vm.$t("data.account_actual_type"),
                  align: "center",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c("span", [
                          _vm._v(
                            _vm._s(
                              _vm.getAccountTypeLabel(
                                scope.row.real_account_type
                              ) || "-"
                            )
                          ),
                        ]),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  label: _vm.$t("data.account_kyc_result"),
                  align: "center",
                  "min-width": "110",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c("span", [
                          _vm._v(
                            _vm._s(
                              _vm.getAccountKycResultLabel(
                                scope.row.account_kyc_result
                              )
                            )
                          ),
                        ]),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { label: _vm.$t("dashboard.fee"), align: "center" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c("span", [
                          _vm._v(
                            _vm._s(
                              _vm._f("toDivideWithDot")(scope.row.fee_split)
                            )
                          ),
                        ]),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  width: "105",
                  label: _vm.$t("merchantAccount.create_time"),
                  align: "center",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _vm._v(
                          " " + _vm._s(scope.row.transaction_create_time) + " "
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  width: "105",
                  label: _vm.$t("merchantAccount.complete_time"),
                  align: "center",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c("span", [
                          _vm._v(
                            _vm._s(scope.row.transaction_return_time || "-")
                          ),
                        ]),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  label: _vm.$t("components.operation"),
                  align: "center",
                  "min-width": "80",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c(
                          "el-tooltip",
                          { attrs: { placement: "top" } },
                          [
                            _c(
                              "div",
                              { attrs: { slot: "content" }, slot: "content" },
                              [
                                _c("span", [
                                  _vm._v(
                                    " " + _vm._s(_vm.$t("components.detail"))
                                  ),
                                ]),
                                _vm._v(" "),
                                _c("br"),
                              ]
                            ),
                            _c("svg-icon", {
                              attrs: {
                                "class-name": "icon-function",
                                "icon-class": "operation-detail",
                              },
                              on: {
                                click: function ($event) {
                                  return _vm.onClickDetailTxt(scope.row)
                                },
                              },
                            }),
                          ],
                          1
                        ),
                      ]
                    },
                  },
                ]),
              }),
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "pagination-container" },
            [
              !_vm.listLoading
                ? _c("paginator", {
                    attrs: { "list-query": _vm.listQuery },
                    on: { "paginator-change": _vm.onClickPaginator },
                  })
                : _vm._e(),
            ],
            1
          ),
        ],
        1
      ),
      _c("CardVerificationDetailModal", {
        ref: "cardVerificationDetailModal",
        attrs: { visible: _vm.detailModalVisible },
        on: {
          "update:visible": function ($event) {
            _vm.detailModalVisible = $event
          },
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }